import { Deal } from '../types/deal';

const CACHE_PREFIX = 'urunn_deal_cache_';
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour

interface CachedDeal {
  deal: Deal;
  timestamp: number;
}

/**
 * Read a cached deal by id. Returns null if missing or expired.
 */
export const getCachedDeal = (dealId: string): Deal | null => {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + dealId);
    if (!raw) return null;
    const cached: CachedDeal = JSON.parse(raw);
    if (Date.now() - cached.timestamp > CACHE_DURATION) {
      localStorage.removeItem(CACHE_PREFIX + dealId);
      return null;
    }
    return cached.deal;
  } catch {
    return null;
  }
};

/**
 * Cache a deal by id.
 */
export const setCachedDeal = (deal: Deal): void => {
  if (!deal?.id) return;
  try {
    const payload: CachedDeal = { deal, timestamp: Date.now() };
    localStorage.setItem(CACHE_PREFIX + deal.id, JSON.stringify(payload));
  } catch (error) {
    console.warn('[dealCache] Failed to cache deal:', error);
  }
};
